var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c(
          "button",
          {
            staticClass: "btn-info btn--bigger",
            on: { click: _vm.consultarComprobantes }
          },
          [
            _c("i", { staticClass: "fa fa-search" }),
            _vm._v(" "),
            _c("span", [_vm._v("Consultar")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      options: _vm.empresas,
                      label: "nombre_comercial",
                      id: "empresa",
                      placeholder: "Seleccione..."
                    },
                    on: { input: _vm.seleccionarEmpresa },
                    model: {
                      value: _vm.selectedEmpresa,
                      callback: function($$v) {
                        _vm.selectedEmpresa = $$v
                      },
                      expression: "selectedEmpresa"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "empresa" } }, [
                    _vm._v("Empresa")
                  ]),
                  _vm._v(" "),
                  _vm.errores.id_empresa
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.id_empresa[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", { attrs: { for: "hoy" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: { type: "radio", id: "hoy", value: "H" },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "H")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Hoy")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ayer" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: { type: "radio", id: "ayer", value: "A" },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "A")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ayer")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "personalizada" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: { type: "radio", id: "personalizada", value: "P" },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "P")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Personalizada")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha === "P",
                      expression: "form.tipoFecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          type: "date",
                          format: "dd-MM-yyyy",
                          id: "desde",
                          lang: "es"
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "desde" } }, [
                        _vm._v("Desde")
                      ]),
                      _vm._v(" "),
                      _vm.errores.desde
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.desde[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha === "P",
                      expression: "form.tipoFecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          type: "date",
                          format: "dd-MM-yyyy",
                          id: "hasta",
                          lang: "es"
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "desde" } }, [
                        _vm._v("Hasta")
                      ]),
                      _vm._v(" "),
                      _vm.errores.hasta
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.hasta[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "###-###-#########",
                        expression: "'###-###-#########'"
                      }
                    ],
                    attrs: {
                      id: "numeroComprobante",
                      placeholder: "###-###-########"
                    },
                    model: {
                      value: _vm.form.numero_documento,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "numero_documento", $$v)
                      },
                      expression: "form.numero_documento"
                    }
                  },
                  [_c("span", [_vm._v("Número de comprobante")])]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "table-responsive mt-3" }, [
              _c("table", [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.comprobantes.length === 0,
                            expression: "comprobantes.length === 0"
                          }
                        ]
                      },
                      [_vm._m(4)]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.comprobantes, function(comprobante, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _vm._v(
                            _vm._s(comprobante.tipo_comprobante.descripcion)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(comprobante.fecha_emision_comprobante))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(comprobante.numero_documento))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                comprobante.total_sin_impuestos !== null
                                  ? parseFloat(
                                      comprobante.total_sin_impuestos
                                    ).toLocaleString(_vm.locale)
                                  : 0
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                comprobante.total_impuestos !== null
                                  ? parseFloat(comprobante.total_impuestos)
                                  : 0.0
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                comprobante.total_descuento !== null
                                  ? parseFloat(comprobante.total_descuento)
                                  : 0.0
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                parseFloat(
                                  comprobante.valor_total
                                ).toLocaleString(_vm.locale)
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "table-actions" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn-light btn--text",
                              attrs: {
                                target: "_blank",
                                href:
                                  _vm.url +
                                  "/comprobantes/" +
                                  comprobante.id_comprobante +
                                  "/ride"
                              }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn-info btn--text",
                              attrs: {
                                target: "_blank",
                                href:
                                  _vm.url +
                                  "/comprobantes/" +
                                  comprobante.id_comprobante +
                                  "/xml"
                              }
                            },
                            [_c("i", { staticClass: "fa fa-download" })]
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta de comprobantes electrónicos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de comprobante")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Número de comprobante")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total sin impuestos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Impuestos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descuento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "8" } }, [
      _c("strong", [_vm._v("No se ha encontrado resultados.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dacccd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dacccd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/portal-cautivo/ConsultaComprobantes.vue
// module id = 429
// module chunks = 0